import React from 'react';
import PropTypes from 'prop-types';
import styles from './FieldTextAction.m.sass';

import cx from 'classnames';
import Field from '../field/Field';

export default function FieldTextAction({input, meta: {touched, error} = {}, type, label, className, actionTitle, onAction, ...rest}) {
  return (
    <Field input={input} touched={touched} error={error} label={label} className={className} rectangular>
      <input {...rest} {...input} className={styles.fieldCoupon_input}/>
      <button className={styles.fieldCoupon_apply} onClick={onAction}>
        {actionTitle}
      </button>
    </Field>
  );
}



// WEBPACK FOOTER //
// ./components/fields/fieldTextAction/FieldTextAction.js